import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
function cov_2cx34lhyte() {
  var path = "/Users/danny.su@opendoor.com/od/code/js/packages/cinderblocks/src/core/AutocompleteInput/AutocompleteInput.tsx";
  var hash = "d5d955a3caac4d815286f497f7a9cd266d66d269";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Users/danny.su@opendoor.com/od/code/js/packages/cinderblocks/src/core/AutocompleteInput/AutocompleteInput.tsx",
    statementMap: {
      "0": {
        start: {
          line: 63,
          column: 23
        },
        end: {
          line: 65,
          column: 2
        }
      },
      "1": {
        start: {
          line: 64,
          column: 2
        },
        end: {
          line: 64,
          column: 46
        }
      },
      "2": {
        start: {
          line: 67,
          column: 26
        },
        end: {
          line: 122,
          column: 1
        }
      },
      "3": {
        start: {
          line: 79,
          column: 26
        },
        end: {
          line: 83,
          column: 12
        }
      },
      "4": {
        start: {
          line: 84,
          column: 23
        },
        end: {
          line: 84,
          column: 85
        }
      },
      "5": {
        start: {
          line: 86,
          column: 2
        },
        end: {
          line: 121,
          column: 4
        }
      },
      "6": {
        start: {
          line: 124,
          column: 26
        },
        end: {
          line: 317,
          column: 1
        }
      },
      "7": {
        start: {
          line: 149,
          column: 44
        },
        end: {
          line: 149,
          column: 83
        }
      },
      "8": {
        start: {
          line: 150,
          column: 36
        },
        end: {
          line: 150,
          column: 51
        }
      },
      "9": {
        start: {
          line: 151,
          column: 24
        },
        end: {
          line: 151,
          column: 28
        }
      },
      "10": {
        start: {
          line: 152,
          column: 27
        },
        end: {
          line: 152,
          column: 57
        }
      },
      "11": {
        start: {
          line: 153,
          column: 19
        },
        end: {
          line: 153,
          column: 55
        }
      },
      "12": {
        start: {
          line: 156,
          column: 2
        },
        end: {
          line: 160,
          column: 29
        }
      },
      "13": {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 159,
          column: 5
        }
      },
      "14": {
        start: {
          line: 158,
          column: 6
        },
        end: {
          line: 158,
          column: 34
        }
      },
      "15": {
        start: {
          line: 162,
          column: 27
        },
        end: {
          line: 168,
          column: 3
        }
      },
      "16": {
        start: {
          line: 163,
          column: 17
        },
        end: {
          line: 166,
          column: 5
        }
      },
      "17": {
        start: {
          line: 164,
          column: 6
        },
        end: {
          line: 164,
          column: 25
        }
      },
      "18": {
        start: {
          line: 165,
          column: 6
        },
        end: {
          line: 165,
          column: 31
        }
      },
      "19": {
        start: {
          line: 170,
          column: 80
        },
        end: {
          line: 197,
          column: 3
        }
      },
      "20": {
        start: {
          line: 171,
          column: 4
        },
        end: {
          line: 196,
          column: 5
        }
      },
      "21": {
        start: {
          line: 172,
          column: 6
        },
        end: {
          line: 172,
          column: 25
        }
      },
      "22": {
        start: {
          line: 173,
          column: 6
        },
        end: {
          line: 177,
          column: 7
        }
      },
      "23": {
        start: {
          line: 175,
          column: 10
        },
        end: {
          line: 175,
          column: 99
        }
      },
      "24": {
        start: {
          line: 176,
          column: 8
        },
        end: {
          line: 176,
          column: 43
        }
      },
      "25": {
        start: {
          line: 178,
          column: 11
        },
        end: {
          line: 196,
          column: 5
        }
      },
      "26": {
        start: {
          line: 179,
          column: 6
        },
        end: {
          line: 179,
          column: 25
        }
      },
      "27": {
        start: {
          line: 180,
          column: 6
        },
        end: {
          line: 184,
          column: 7
        }
      },
      "28": {
        start: {
          line: 182,
          column: 10
        },
        end: {
          line: 182,
          column: 99
        }
      },
      "29": {
        start: {
          line: 183,
          column: 8
        },
        end: {
          line: 183,
          column: 43
        }
      },
      "30": {
        start: {
          line: 185,
          column: 11
        },
        end: {
          line: 196,
          column: 5
        }
      },
      "31": {
        start: {
          line: 186,
          column: 6
        },
        end: {
          line: 186,
          column: 25
        }
      },
      "32": {
        start: {
          line: 187,
          column: 6
        },
        end: {
          line: 190,
          column: 7
        }
      },
      "33": {
        start: {
          line: 188,
          column: 8
        },
        end: {
          line: 188,
          column: 43
        }
      },
      "34": {
        start: {
          line: 189,
          column: 8
        },
        end: {
          line: 189,
          column: 33
        }
      },
      "35": {
        start: {
          line: 191,
          column: 11
        },
        end: {
          line: 196,
          column: 5
        }
      },
      "36": {
        start: {
          line: 192,
          column: 6
        },
        end: {
          line: 192,
          column: 34
        }
      },
      "37": {
        start: {
          line: 193,
          column: 6
        },
        end: {
          line: 193,
          column: 19
        }
      },
      "38": {
        start: {
          line: 195,
          column: 6
        },
        end: {
          line: 195,
          column: 34
        }
      },
      "39": {
        start: {
          line: 199,
          column: 30
        },
        end: {
          line: 207,
          column: 3
        }
      },
      "40": {
        start: {
          line: 201,
          column: 6
        },
        end: {
          line: 204,
          column: 7
        }
      },
      "41": {
        start: {
          line: 202,
          column: 8
        },
        end: {
          line: 202,
          column: 28
        }
      },
      "42": {
        start: {
          line: 203,
          column: 8
        },
        end: {
          line: 203,
          column: 19
        }
      },
      "43": {
        start: {
          line: 209,
          column: 31
        },
        end: {
          line: 212,
          column: 15
        }
      },
      "44": {
        start: {
          line: 210,
          column: 4
        },
        end: {
          line: 210,
          column: 23
        }
      },
      "45": {
        start: {
          line: 211,
          column: 4
        },
        end: {
          line: 211,
          column: 16
        }
      },
      "46": {
        start: {
          line: 214,
          column: 26
        },
        end: {
          line: 216,
          column: 8
        }
      },
      "47": {
        start: {
          line: 215,
          column: 4
        },
        end: {
          line: 215,
          column: 23
        }
      },
      "48": {
        start: {
          line: 218,
          column: 23
        },
        end: {
          line: 218,
          column: 53
        }
      },
      "49": {
        start: {
          line: 220,
          column: 2
        },
        end: {
          line: 314,
          column: 3
        }
      },
      "50": {
        start: {
          line: 221,
          column: 32
        },
        end: {
          line: 243,
          column: 5
        }
      },
      "51": {
        start: {
          line: 227,
          column: 31
        },
        end: {
          line: 229,
          column: 48
        }
      },
      "52": {
        start: {
          line: 230,
          column: 8
        },
        end: {
          line: 230,
          column: 39
        }
      },
      "53": {
        start: {
          line: 245,
          column: 4
        },
        end: {
          line: 251,
          column: 5
        }
      },
      "54": {
        start: {
          line: 246,
          column: 6
        },
        end: {
          line: 246,
          column: 35
        }
      },
      "55": {
        start: {
          line: 247,
          column: 11
        },
        end: {
          line: 251,
          column: 5
        }
      },
      "56": {
        start: {
          line: 248,
          column: 6
        },
        end: {
          line: 248,
          column: 39
        }
      },
      "57": {
        start: {
          line: 250,
          column: 6
        },
        end: {
          line: 250,
          column: 48
        }
      },
      "58": {
        start: {
          line: 254,
          column: 4
        },
        end: {
          line: 260,
          column: 5
        }
      },
      "59": {
        start: {
          line: 255,
          column: 6
        },
        end: {
          line: 259,
          column: 8
        }
      },
      "60": {
        start: {
          line: 262,
          column: 4
        },
        end: {
          line: 313,
          column: 6
        }
      },
      "61": {
        start: {
          line: 271,
          column: 35
        },
        end: {
          line: 271,
          column: 58
        }
      },
      "62": {
        start: {
          line: 273,
          column: 16
        },
        end: {
          line: 306,
          column: 18
        }
      },
      "63": {
        start: {
          line: 316,
          column: 2
        },
        end: {
          line: 316,
          column: 14
        }
      }
    },
    fnMap: {
      "0": {
        name: "ListBoxElement",
        decl: {
          start: {
            line: 63,
            column: 49
          },
          end: {
            line: 63,
            column: 63
          }
        },
        loc: {
          start: {
            line: 63,
            column: 90
          },
          end: {
            line: 65,
            column: 1
          }
        },
        line: 63
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 67,
            column: 26
          },
          end: {
            line: 67,
            column: 27
          }
        },
        loc: {
          start: {
            line: 77,
            column: 6
          },
          end: {
            line: 122,
            column: 1
          }
        },
        line: 77
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 124,
            column: 26
          },
          end: {
            line: 124,
            column: 27
          }
        },
        loc: {
          start: {
            line: 148,
            column: 33
          },
          end: {
            line: 317,
            column: 1
          }
        },
        line: 148
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 156,
            column: 12
          },
          end: {
            line: 156,
            column: 13
          }
        },
        loc: {
          start: {
            line: 156,
            column: 18
          },
          end: {
            line: 160,
            column: 3
          }
        },
        line: 156
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 163,
            column: 5
          }
        },
        loc: {
          start: {
            line: 163,
            column: 17
          },
          end: {
            line: 166,
            column: 5
          }
        },
        line: 163
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 163,
            column: 17
          },
          end: {
            line: 163,
            column: 18
          }
        },
        loc: {
          start: {
            line: 163,
            column: 23
          },
          end: {
            line: 166,
            column: 5
          }
        },
        line: 163
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 170,
            column: 80
          },
          end: {
            line: 170,
            column: 81
          }
        },
        loc: {
          start: {
            line: 170,
            column: 87
          },
          end: {
            line: 197,
            column: 3
          }
        },
        line: 170
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 200,
            column: 4
          },
          end: {
            line: 200,
            column: 5
          }
        },
        loc: {
          start: {
            line: 200,
            column: 45
          },
          end: {
            line: 205,
            column: 5
          }
        },
        line: 200
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 209,
            column: 43
          },
          end: {
            line: 209,
            column: 44
          }
        },
        loc: {
          start: {
            line: 209,
            column: 49
          },
          end: {
            line: 212,
            column: 3
          }
        },
        line: 209
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 214,
            column: 38
          },
          end: {
            line: 214,
            column: 39
          }
        },
        loc: {
          start: {
            line: 214,
            column: 63
          },
          end: {
            line: 216,
            column: 3
          }
        },
        line: 214
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 226,
            column: 20
          },
          end: {
            line: 226,
            column: 21
          }
        },
        loc: {
          start: {
            line: 226,
            column: 38
          },
          end: {
            line: 231,
            column: 7
          }
        },
        line: 226
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 270,
            column: 25
          },
          end: {
            line: 270,
            column: 26
          }
        },
        loc: {
          start: {
            line: 270,
            column: 42
          },
          end: {
            line: 307,
            column: 15
          }
        },
        line: 270
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 70,
            column: 2
          },
          end: {
            line: 70,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 70,
            column: 14
          },
          end: {
            line: 70,
            column: 27
          }
        }],
        line: 70
      },
      "1": {
        loc: {
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 71,
            column: 17
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 71,
            column: 9
          },
          end: {
            line: 71,
            column: 17
          }
        }],
        line: 71
      },
      "2": {
        loc: {
          start: {
            line: 84,
            column: 23
          },
          end: {
            line: 84,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 84,
            column: 23
          },
          end: {
            line: 84,
            column: 76
          }
        }, {
          start: {
            line: 84,
            column: 80
          },
          end: {
            line: 84,
            column: 85
          }
        }],
        line: 84
      },
      "3": {
        loc: {
          start: {
            line: 137,
            column: 2
          },
          end: {
            line: 137,
            column: 36
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 137,
            column: 14
          },
          end: {
            line: 137,
            column: 36
          }
        }],
        line: 137
      },
      "4": {
        loc: {
          start: {
            line: 142,
            column: 2
          },
          end: {
            line: 142,
            column: 17
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 142,
            column: 9
          },
          end: {
            line: 142,
            column: 17
          }
        }],
        line: 142
      },
      "5": {
        loc: {
          start: {
            line: 153,
            column: 19
          },
          end: {
            line: 153,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 153,
            column: 19
          },
          end: {
            line: 153,
            column: 35
          }
        }, {
          start: {
            line: 153,
            column: 39
          },
          end: {
            line: 153,
            column: 55
          }
        }],
        line: 153
      },
      "6": {
        loc: {
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 159,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 159,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 157
      },
      "7": {
        loc: {
          start: {
            line: 157,
            column: 8
          },
          end: {
            line: 157,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 157,
            column: 8
          },
          end: {
            line: 157,
            column: 35
          }
        }, {
          start: {
            line: 157,
            column: 39
          },
          end: {
            line: 157,
            column: 68
          }
        }],
        line: 157
      },
      "8": {
        loc: {
          start: {
            line: 171,
            column: 4
          },
          end: {
            line: 196,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 171,
            column: 4
          },
          end: {
            line: 196,
            column: 5
          }
        }, {
          start: {
            line: 178,
            column: 11
          },
          end: {
            line: 196,
            column: 5
          }
        }],
        line: 171
      },
      "9": {
        loc: {
          start: {
            line: 173,
            column: 6
          },
          end: {
            line: 177,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 173,
            column: 6
          },
          end: {
            line: 177,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 173
      },
      "10": {
        loc: {
          start: {
            line: 175,
            column: 10
          },
          end: {
            line: 175,
            column: 99
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 175,
            column: 78
          },
          end: {
            line: 175,
            column: 79
          }
        }, {
          start: {
            line: 175,
            column: 82
          },
          end: {
            line: 175,
            column: 99
          }
        }],
        line: 175
      },
      "11": {
        loc: {
          start: {
            line: 175,
            column: 10
          },
          end: {
            line: 175,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 175,
            column: 10
          },
          end: {
            line: 175,
            column: 37
          }
        }, {
          start: {
            line: 175,
            column: 41
          },
          end: {
            line: 175,
            column: 75
          }
        }],
        line: 175
      },
      "12": {
        loc: {
          start: {
            line: 178,
            column: 11
          },
          end: {
            line: 196,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 178,
            column: 11
          },
          end: {
            line: 196,
            column: 5
          }
        }, {
          start: {
            line: 185,
            column: 11
          },
          end: {
            line: 196,
            column: 5
          }
        }],
        line: 178
      },
      "13": {
        loc: {
          start: {
            line: 180,
            column: 6
          },
          end: {
            line: 184,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 180,
            column: 6
          },
          end: {
            line: 184,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 180
      },
      "14": {
        loc: {
          start: {
            line: 182,
            column: 10
          },
          end: {
            line: 182,
            column: 99
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 182,
            column: 63
          },
          end: {
            line: 182,
            column: 79
          }
        }, {
          start: {
            line: 182,
            column: 82
          },
          end: {
            line: 182,
            column: 99
          }
        }],
        line: 182
      },
      "15": {
        loc: {
          start: {
            line: 182,
            column: 10
          },
          end: {
            line: 182,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 182,
            column: 10
          },
          end: {
            line: 182,
            column: 37
          }
        }, {
          start: {
            line: 182,
            column: 41
          },
          end: {
            line: 182,
            column: 60
          }
        }],
        line: 182
      },
      "16": {
        loc: {
          start: {
            line: 185,
            column: 11
          },
          end: {
            line: 196,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 185,
            column: 11
          },
          end: {
            line: 196,
            column: 5
          }
        }, {
          start: {
            line: 191,
            column: 11
          },
          end: {
            line: 196,
            column: 5
          }
        }],
        line: 185
      },
      "17": {
        loc: {
          start: {
            line: 187,
            column: 6
          },
          end: {
            line: 190,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 187,
            column: 6
          },
          end: {
            line: 190,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 187
      },
      "18": {
        loc: {
          start: {
            line: 187,
            column: 10
          },
          end: {
            line: 187,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 187,
            column: 10
          },
          end: {
            line: 187,
            column: 37
          }
        }, {
          start: {
            line: 187,
            column: 41
          },
          end: {
            line: 187,
            column: 61
          }
        }],
        line: 187
      },
      "19": {
        loc: {
          start: {
            line: 191,
            column: 11
          },
          end: {
            line: 196,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 191,
            column: 11
          },
          end: {
            line: 196,
            column: 5
          }
        }, {
          start: {
            line: 194,
            column: 11
          },
          end: {
            line: 196,
            column: 5
          }
        }],
        line: 191
      },
      "20": {
        loc: {
          start: {
            line: 201,
            column: 6
          },
          end: {
            line: 204,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 201,
            column: 6
          },
          end: {
            line: 204,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 201
      },
      "21": {
        loc: {
          start: {
            line: 218,
            column: 23
          },
          end: {
            line: 218,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 218,
            column: 23
          },
          end: {
            line: 218,
            column: 40
          }
        }, {
          start: {
            line: 218,
            column: 44
          },
          end: {
            line: 218,
            column: 53
          }
        }],
        line: 218
      },
      "22": {
        loc: {
          start: {
            line: 220,
            column: 2
          },
          end: {
            line: 314,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 220,
            column: 2
          },
          end: {
            line: 314,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 220
      },
      "23": {
        loc: {
          start: {
            line: 241,
            column: 23
          },
          end: {
            line: 241,
            column: 54
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 241,
            column: 38
          },
          end: {
            line: 241,
            column: 44
          }
        }, {
          start: {
            line: 241,
            column: 47
          },
          end: {
            line: 241,
            column: 54
          }
        }],
        line: 241
      },
      "24": {
        loc: {
          start: {
            line: 245,
            column: 4
          },
          end: {
            line: 251,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 245,
            column: 4
          },
          end: {
            line: 251,
            column: 5
          }
        }, {
          start: {
            line: 247,
            column: 11
          },
          end: {
            line: 251,
            column: 5
          }
        }],
        line: 245
      },
      "25": {
        loc: {
          start: {
            line: 245,
            column: 8
          },
          end: {
            line: 245,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 245,
            column: 8
          },
          end: {
            line: 245,
            column: 18
          }
        }, {
          start: {
            line: 245,
            column: 22
          },
          end: {
            line: 245,
            column: 27
          }
        }],
        line: 245
      },
      "26": {
        loc: {
          start: {
            line: 247,
            column: 11
          },
          end: {
            line: 251,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 247,
            column: 11
          },
          end: {
            line: 251,
            column: 5
          }
        }, {
          start: {
            line: 249,
            column: 11
          },
          end: {
            line: 251,
            column: 5
          }
        }],
        line: 247
      },
      "27": {
        loc: {
          start: {
            line: 254,
            column: 4
          },
          end: {
            line: 260,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 254,
            column: 4
          },
          end: {
            line: 260,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 254
      },
      "28": {
        loc: {
          start: {
            line: 254,
            column: 8
          },
          end: {
            line: 254,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 254,
            column: 8
          },
          end: {
            line: 254,
            column: 20
          }
        }, {
          start: {
            line: 254,
            column: 25
          },
          end: {
            line: 254,
            column: 41
          }
        }, {
          start: {
            line: 254,
            column: 45
          },
          end: {
            line: 254,
            column: 57
          }
        }],
        line: 254
      },
      "29": {
        loc: {
          start: {
            line: 268,
            column: 11
          },
          end: {
            line: 310,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 268,
            column: 11
          },
          end: {
            line: 268,
            column: 23
          }
        }, {
          start: {
            line: 268,
            column: 28
          },
          end: {
            line: 268,
            column: 44
          }
        }, {
          start: {
            line: 268,
            column: 48
          },
          end: {
            line: 268,
            column: 60
          }
        }, {
          start: {
            line: 269,
            column: 12
          },
          end: {
            line: 309,
            column: 32
          }
        }],
        line: 268
      },
      "30": {
        loc: {
          start: {
            line: 279,
            column: 35
          },
          end: {
            line: 279,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 279,
            column: 35
          },
          end: {
            line: 279,
            column: 45
          }
        }, {
          start: {
            line: 279,
            column: 49
          },
          end: {
            line: 279,
            column: 58
          }
        }],
        line: 279
      },
      "31": {
        loc: {
          start: {
            line: 292,
            column: 24
          },
          end: {
            line: 292,
            column: 90
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 292,
            column: 37
          },
          end: {
            line: 292,
            column: 67
          }
        }, {
          start: {
            line: 292,
            column: 70
          },
          end: {
            line: 292,
            column: 90
          }
        }],
        line: 292
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0, 0],
      "3": [0],
      "4": [0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0, 0],
      "29": [0, 0, 0, 0],
      "30": [0, 0],
      "31": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d5d955a3caac4d815286f497f7a9cd266d66d269"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2cx34lhyte = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
cov_2cx34lhyte();
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Box as BricksNextBox, PressableBox, TextInput } from '@opendoor/bricks-next';
// Simple wrapper component similar to PickerSelect's approach
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var ListBoxElement = (cov_2cx34lhyte().s[0]++, /*#__PURE__*/React.forwardRef(function ListBoxElement(props, forwardedRef) {
  cov_2cx34lhyte().f[0]++;
  cov_2cx34lhyte().s[1]++;
  return /*#__PURE__*/React.createElement("ul", _extends({}, props, {
    ref: forwardedRef
  }));
}));
cov_2cx34lhyte().s[2]++;
var BricksNextListBox = function BricksNextListBox(_ref) {
  var children = _ref.children,
    listBoxId = _ref.listBoxId,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? (cov_2cx34lhyte().b[0][0]++, 'suggestions') : _ref$ariaLabel,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? (cov_2cx34lhyte().b[1][0]++, 'medium') : _ref$size;
  cov_2cx34lhyte().f[1]++;
  // Map size to border radius tokens that match TextInput
  var borderRadiusMap = (cov_2cx34lhyte().s[3]++, {
    small: '$7x',
    medium: '$9x',
    large: '$12x'
  });
  var borderRadius = (cov_2cx34lhyte().s[4]++, (cov_2cx34lhyte().b[2][0]++, borderRadiusMap[size]) || (cov_2cx34lhyte().b[2][1]++, '$9x'));
  cov_2cx34lhyte().s[5]++;
  return /*#__PURE__*/React.createElement(BricksNextBox, {
    borderBottomLeftRadius: borderRadius,
    borderBottomRightRadius: borderRadius,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    maxHeight: 450,
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    marginTop: -1.5,
    borderLeftWidth: 1.5,
    borderRightWidth: 1.5,
    borderBottomWidth: 1.5,
    borderTopWidth: 0,
    borderStyle: "solid",
    borderColor: "$borderAccentBrand",
    backgroundColor: "$backgroundPrimary",
    overflow: "hidden",
    zIndex: 1000
  }, /*#__PURE__*/React.createElement(ListBoxElement, {
    role: "listbox",
    "aria-label": ariaLabel,
    id: listBoxId,
    style: {
      padding: 0,
      margin: 0,
      listStyleType: 'none'
    }
  }, children));
};
cov_2cx34lhyte().s[6]++;
var AutocompleteInput = function AutocompleteInput(_ref2) {
  var id = _ref2.id,
    label = _ref2.label,
    hideLabel = _ref2.hideLabel,
    placeholder = _ref2.placeholder,
    disabled = _ref2.disabled,
    items = _ref2.items,
    searchTerm = _ref2.searchTerm,
    onSearchChange = _ref2.onSearchChange,
    onItemSelect = _ref2.onItemSelect,
    renderItem = _ref2.renderItem,
    suffix = _ref2.suffix,
    customAction = _ref2.customAction,
    _ref2$listBoxId = _ref2.listBoxId,
    listBoxId = _ref2$listBoxId === void 0 ? (cov_2cx34lhyte().b[3][0]++, 'autocomplete-listbox') : _ref2$listBoxId,
    listBoxAriaLabel = _ref2.listBoxAriaLabel,
    onEscape = _ref2.onEscape,
    onFocus = _ref2.onFocus,
    onBlur = _ref2.onBlur,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? (cov_2cx34lhyte().b[4][0]++, 'medium') : _ref2$size,
    supportText = _ref2.supportText,
    errorText = _ref2.errorText,
    invalid = _ref2.invalid,
    required = _ref2.required,
    externalInputRef = _ref2.inputRef;
  cov_2cx34lhyte().f[2]++;
  var _ref3 = (cov_2cx34lhyte().s[7]++, useState(undefined)),
    _ref4 = _slicedToArray(_ref3, 2),
    selectedIndex = _ref4[0],
    setSelectedIndex = _ref4[1];
  var _ref5 = (cov_2cx34lhyte().s[8]++, useState(false)),
    _ref6 = _slicedToArray(_ref5, 2),
    isFocused = _ref6[0],
    setIsFocused = _ref6[1];
  var useBricksNext = (cov_2cx34lhyte().s[9]++, true);
  var internalInputRef = (cov_2cx34lhyte().s[10]++, useRef(null));
  var inputRef = (cov_2cx34lhyte().s[11]++, (cov_2cx34lhyte().b[5][0]++, externalInputRef) || (cov_2cx34lhyte().b[5][1]++, internalInputRef));

  // Reset selection when items change to prevent stale index
  cov_2cx34lhyte().s[12]++;
  useEffect(function () {
    cov_2cx34lhyte().f[3]++;
    cov_2cx34lhyte().s[13]++;
    if ((cov_2cx34lhyte().b[7][0]++, selectedIndex !== undefined) && (cov_2cx34lhyte().b[7][1]++, selectedIndex >= items.length)) {
      cov_2cx34lhyte().b[6][0]++;
      cov_2cx34lhyte().s[14]++;
      setSelectedIndex(undefined);
    } else {
      cov_2cx34lhyte().b[6][1]++;
    }
  }, [items, selectedIndex]);
  var handleItemSelect = (cov_2cx34lhyte().s[15]++, useCallback(function (item) {
    cov_2cx34lhyte().f[4]++;
    cov_2cx34lhyte().s[16]++;
    return function () {
      var _inputRef$current;
      cov_2cx34lhyte().f[5]++;
      cov_2cx34lhyte().s[17]++;
      onItemSelect(item);
      cov_2cx34lhyte().s[18]++;
      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.blur();
    };
  }, [onItemSelect, inputRef]));
  cov_2cx34lhyte().s[19]++;
  var onKeyDown = function onKeyDown(e) {
    cov_2cx34lhyte().f[6]++;
    cov_2cx34lhyte().s[20]++;
    if (e.key === 'ArrowDown') {
      cov_2cx34lhyte().b[8][0]++;
      cov_2cx34lhyte().s[21]++;
      e.preventDefault();
      cov_2cx34lhyte().s[22]++;
      if (items.length > 0) {
        cov_2cx34lhyte().b[9][0]++;
        var newSelectedIndex = (cov_2cx34lhyte().s[23]++, (cov_2cx34lhyte().b[11][0]++, selectedIndex === undefined) || (cov_2cx34lhyte().b[11][1]++, selectedIndex === items.length - 1) ? (cov_2cx34lhyte().b[10][0]++, 0) : (cov_2cx34lhyte().b[10][1]++, selectedIndex + 1));
        cov_2cx34lhyte().s[24]++;
        setSelectedIndex(newSelectedIndex);
      } else {
        cov_2cx34lhyte().b[9][1]++;
      }
    } else {
      cov_2cx34lhyte().b[8][1]++;
      cov_2cx34lhyte().s[25]++;
      if (e.key === 'ArrowUp') {
        cov_2cx34lhyte().b[12][0]++;
        cov_2cx34lhyte().s[26]++;
        e.preventDefault();
        cov_2cx34lhyte().s[27]++;
        if (items.length > 0) {
          cov_2cx34lhyte().b[13][0]++;
          var _newSelectedIndex = (cov_2cx34lhyte().s[28]++, (cov_2cx34lhyte().b[15][0]++, selectedIndex === undefined) || (cov_2cx34lhyte().b[15][1]++, selectedIndex === 0) ? (cov_2cx34lhyte().b[14][0]++, items.length - 1) : (cov_2cx34lhyte().b[14][1]++, selectedIndex - 1));
          cov_2cx34lhyte().s[29]++;
          setSelectedIndex(_newSelectedIndex);
        } else {
          cov_2cx34lhyte().b[13][1]++;
        }
      } else {
        cov_2cx34lhyte().b[12][1]++;
        cov_2cx34lhyte().s[30]++;
        if (e.key === 'Enter') {
          cov_2cx34lhyte().b[16][0]++;
          cov_2cx34lhyte().s[31]++;
          e.preventDefault();
          cov_2cx34lhyte().s[32]++;
          if ((cov_2cx34lhyte().b[18][0]++, selectedIndex !== undefined) && (cov_2cx34lhyte().b[18][1]++, items[selectedIndex])) {
            var _inputRef$current2;
            cov_2cx34lhyte().b[17][0]++;
            cov_2cx34lhyte().s[33]++;
            onItemSelect(items[selectedIndex]);
            cov_2cx34lhyte().s[34]++;
            (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.blur();
          } else {
            cov_2cx34lhyte().b[17][1]++;
          }
        } else {
          cov_2cx34lhyte().b[16][1]++;
          cov_2cx34lhyte().s[35]++;
          if (e.key === 'Escape') {
            cov_2cx34lhyte().b[19][0]++;
            cov_2cx34lhyte().s[36]++;
            setSelectedIndex(undefined);
            cov_2cx34lhyte().s[37]++;
            onEscape === null || onEscape === void 0 || onEscape();
          } else {
            cov_2cx34lhyte().b[19][1]++;
            cov_2cx34lhyte().s[38]++;
            setSelectedIndex(undefined);
          }
        }
      }
    }
  };
  var handleContainerBlur = (cov_2cx34lhyte().s[39]++, useCallback(function (e) {
    cov_2cx34lhyte().f[7]++;
    cov_2cx34lhyte().s[40]++;
    if (!e.currentTarget.contains(e.relatedTarget)) {
      cov_2cx34lhyte().b[20][0]++;
      cov_2cx34lhyte().s[41]++;
      setIsFocused(false);
      cov_2cx34lhyte().s[42]++;
      onBlur === null || onBlur === void 0 || onBlur();
    } else {
      cov_2cx34lhyte().b[20][1]++;
    }
  }, [onBlur]));
  var handleContainerFocus = (cov_2cx34lhyte().s[43]++, useCallback(function () {
    cov_2cx34lhyte().f[8]++;
    cov_2cx34lhyte().s[44]++;
    setIsFocused(true);
    cov_2cx34lhyte().s[45]++;
    onFocus === null || onFocus === void 0 || onFocus();
  }, [onFocus]));
  var handleMouseDown = (cov_2cx34lhyte().s[46]++, useCallback(function (e) {
    cov_2cx34lhyte().f[9]++;
    cov_2cx34lhyte().s[47]++;
    e.preventDefault();
  }, []));
  var showDropdown = (cov_2cx34lhyte().s[48]++, (cov_2cx34lhyte().b[21][0]++, searchTerm !== '') && (cov_2cx34lhyte().b[21][1]++, isFocused));
  cov_2cx34lhyte().s[49]++;
  if (useBricksNext) {
    cov_2cx34lhyte().b[22][0]++;
    var textInputProps = (cov_2cx34lhyte().s[50]++, {
      id: id,
      placeholder: placeholder,
      disabled: disabled,
      value: searchTerm,
      onChangeText: function onChangeText(text) {
        cov_2cx34lhyte().f[10]++;
        var syntheticEvent = (cov_2cx34lhyte().s[51]++, {
          target: {
            value: text
          }
        });
        cov_2cx34lhyte().s[52]++;
        onSearchChange(syntheticEvent);
      },
      onKeyPress: onKeyDown,
      size: size,
      supportText: supportText,
      errorText: errorText,
      invalid: invalid,
      required: required,
      autoComplete: 'off',
      role: 'combobox',
      'aria-autocomplete': 'list',
      'aria-expanded': showDropdown ? (cov_2cx34lhyte().b[23][0]++, 'true') : (cov_2cx34lhyte().b[23][1]++, 'false'),
      'aria-controls': listBoxId
    });
    cov_2cx34lhyte().s[53]++;
    if ((cov_2cx34lhyte().b[25][0]++, !hideLabel) && (cov_2cx34lhyte().b[25][1]++, label)) {
      cov_2cx34lhyte().b[24][0]++;
      cov_2cx34lhyte().s[54]++;
      textInputProps.title = label;
    } else {
      cov_2cx34lhyte().b[24][1]++;
      cov_2cx34lhyte().s[55]++;
      if (label) {
        cov_2cx34lhyte().b[26][0]++;
        cov_2cx34lhyte().s[56]++;
        textInputProps.ariaLabel = label;
      } else {
        cov_2cx34lhyte().b[26][1]++;
        cov_2cx34lhyte().s[57]++;
        textInputProps.ariaLabel = 'Search input';
      }
    }

    // Modify border styling when dropdown is showing AND there are items or customAction to display
    cov_2cx34lhyte().s[58]++;
    if ((cov_2cx34lhyte().b[28][0]++, showDropdown) && ((cov_2cx34lhyte().b[28][1]++, items.length > 0) || (cov_2cx34lhyte().b[28][2]++, customAction))) {
      cov_2cx34lhyte().b[27][0]++;
      cov_2cx34lhyte().s[59]++;
      textInputProps.frameProps = {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderBottomWidth: 0
      };
    } else {
      cov_2cx34lhyte().b[27][1]++;
    }
    cov_2cx34lhyte().s[60]++;
    return /*#__PURE__*/React.createElement(BricksNextBox, {
      onFocus: handleContainerFocus,
      onBlur: handleContainerBlur
    }, /*#__PURE__*/React.createElement(BricksNextBox, {
      position: "relative"
    }, /*#__PURE__*/React.createElement(TextInput, _extends({}, textInputProps, {
      ref: inputRef
    }), suffix), (cov_2cx34lhyte().b[29][0]++, showDropdown) && ((cov_2cx34lhyte().b[29][1]++, items.length > 0) || (cov_2cx34lhyte().b[29][2]++, customAction)) && (cov_2cx34lhyte().b[29][3]++, /*#__PURE__*/React.createElement(BricksNextListBox, {
      listBoxId: listBoxId,
      ariaLabel: listBoxAriaLabel,
      size: size
    }, items.map(function (item, index) {
      cov_2cx34lhyte().f[11]++;
      var isSelected = (cov_2cx34lhyte().s[61]++, selectedIndex === index);
      cov_2cx34lhyte().s[62]++;
      return /*#__PURE__*/React.createElement(BricksNextBox, {
        tag: "li",
        id: "autocomplete-options",
        key: item.id,
        role: "option",
        "aria-selected": (cov_2cx34lhyte().b[30][0]++, isSelected) || (cov_2cx34lhyte().b[30][1]++, undefined),
        overflow: 'hidden'
      }, /*#__PURE__*/React.createElement(PressableBox, {
        zIndex: 2,
        justifyContent: "flex-start",
        onMouseDown: handleMouseDown,
        analyticsName: "",
        "aria-label": item.ariaLabel,
        animation: "accelerateDecelerateFastest",
        height: "100%",
        width: "100%",
        backgroundColor: isSelected ? (cov_2cx34lhyte().b[31][0]++, '$backgroundStateHoverPrimary') : (cov_2cx34lhyte().b[31][1]++, '$backgroundPrimary'),
        hoverStyle: {
          backgroundColor: '$backgroundStateHoverPrimary'
        },
        onPress: handleItemSelect(item),
        pressStyle: {
          scale: 0.98
        },
        padding: 10
      }, renderItem(item, isSelected)));
    }), customAction))));
  } else {
    cov_2cx34lhyte().b[22][1]++;
  }
  cov_2cx34lhyte().s[63]++;
  return null;
};
export default AutocompleteInput;
//# sourceMappingURL=AutocompleteInput.mjs.map